// extracted by mini-css-extract-plugin
export default {"headerTop":"styles_headerTop__7F7lR","title":"styles_title__eHOSY"};